import { makeAutoObservable } from 'mobx';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import { corporateAccountsService } from '../services/corporateAccountsService';
import { deleteItemByField, updateItemByField } from '../../shared/utils/arrayUtils';
import {
  CorporateAccount,
  CorporateAccountFormValues,
} from '../interfaces/CorporateAccount';

class CorporateAccountsStore {
  isModalOpened: boolean = false;
  formDefaultValues: CorporateAccountFormValues | null = null;
  currentModalAccountId: number | null = null;
  corporateAccounts: CorporateAccount[] = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.isModalOpened = false;
    this.formDefaultValues = null;
    this.currentModalAccountId = null;
    this.corporateAccounts = [];
  }

  async getCorporateAccounts() {
    const response = await corporateAccountsService.getCorporateAccounts();
    this.setAccounts(response.accounts);
  }

  async deleteAccount(id: number) {
    await corporateAccountsService.deleteCorporateAccount(id);

    const accountsWithoutDeleted = deleteItemByField(this.corporateAccounts, { id });
    this.setAccounts(accountsWithoutDeleted);
  }

  async addNewAccount(data: CorporateAccountFormValues) {
    const newAccount = await corporateAccountsService.createCorporateAccount(data);
    this.setAccounts([...this.corporateAccounts, newAccount]);
  }

  async editCorporateAccount(data: CorporateAccountFormValues, id: number) {
    const editedAccount = await corporateAccountsService.editCorporateAccount(data, id);
    const accounts = updateItemByField(this.corporateAccounts, editedAccount, { id });

    this.setAccounts(accounts);
  }

  setAccounts(accounts: CorporateAccount[]) {
    this.corporateAccounts = accounts;
  }

  closeModal() {
    this.isModalOpened = false;
    this.formDefaultValues = null;
    this.currentModalAccountId = null;
  }

  openModal(formDefaultValues?: CorporateAccountFormValues, id?: number) {
    const isEditAccountModal = formDefaultValues && id;
    if (isEditAccountModal) {
      this.setFormDefaultValues(formDefaultValues);
      this.setCurrentModalAccountId(id);
    }
    this.setIsModalOpened(true);
  }

  setIsModalOpened(value: boolean) {
    this.isModalOpened = value;
  }

  setCurrentModalAccountId(id: number) {
    this.currentModalAccountId = id;
  }

  setFormDefaultValues(data: CorporateAccountFormValues | null) {
    this.formDefaultValues = data;
  }
}

const corporateAccountsStore = new CorporateAccountsStore();

resetAllStore.addResetMethod(corporateAccountsStore.setDefaultValues);

export { corporateAccountsStore, CorporateAccountsStore };
